import {Component} from "@angular/core";
import {Field} from "../models/field.model";

@Component({
    selector: "tig-form-line",
    template: `<hr class="hr-line-solid">`
})
export class FormLineComponent extends Field
{} // end class FormLineComponent